/*
 * @Author: your name
 * @Date: 2021-04-27 10:26:44
 * @LastEditTime: 2021-05-06 18:18:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \medicalTools\src\utils\loginByAppOrH5.js
 */
import storage from 'storejs'
import storageByCode from "../utils/storageByCode";
import store from './../store'

/** 通过APP或者H5登陆 */
export const toLoginByAppOrH5 = function () {
  if (store.state.isApp) {
    toLogin()
    loginCallBack(closeView)
    appAppWillAppearOrDisappear_ios(closeView)
  } else {
    storageByCode('from', window.location.href)
    window.location.href=window.web_Url + '/testLogin/build/index.html?loginEntrance=medicalTools'
  }
}






// WEBPACK FOOTER //
// ./src/utils/loginByAppOrH5.js